import { Box, Container } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { useT } from '@clara/locale'
import { Button, EmptyState } from '@clara/ui'

import { ReactComponent as ErrorImg } from 'assets/images/request-error.svg'
import { useManageReimbursement } from '../stores/manage-reimbursement-store'

export function ManageReimbursementError() {
  const { t } = useT('reimbursements')

  const navigate = useNavigate()
  const store = useManageReimbursement()

  return (
    <Container
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <EmptyState
        direction="row"
        headline={t('create.request.error.title')}
        tagline={t('create.request.error.description')}
        renderImage={() => (
          <Box sx={(theme) => ({ width: `${theme.spacing(21)}` })}>
            <ErrorImg />
          </Box>
        )}
        primaryAction={
          <Button
            sx={(theme) => ({ minWidth: `${theme.spacing(22.5)}` })}
            onClick={() => navigate('/reimbursements')}
          >
            {t('create.request.action.done')}
          </Button>
        }
        secondaryAction={
          <Button
            sx={(theme) => ({ minWidth: `${theme.spacing(22.5)}` })}
            variant="secondary"
            onClick={() => {
              store.resetStore()
              navigate('/reimbursements/create')
            }}
          >
            {t('main.actions.add.request')}
          </Button>
        }
      />
    </Container>
  )
}
